"use client";

import { Play } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
interface Teacher {
  id: number;
  name: string;
  position: string;
  bio: string;
  image: string;
}
const teachers: Teacher[] = [{
  id: 1,
  name: "David Lorey",
  position: "Senior Dharma Teacher",
  bio: "Specializes in mindfulness and Zen meditation, with over 20 years of practice.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1444982/img/teacher_a_portrait.png"
}, {
  id: 2,
  name: "Ying Chen",
  position: "Retreat Coordinator",
  bio: "Experienced in guiding retreats and facilitating group practices.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1444982/img/teacher_b_portrait.png"
}, {
  id: 3,
  name: "Diana Clark",
  position: "Dharma Speaker",
  bio: "Focuses on integrating teachings into daily life and community service.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1444982/img/teacher_c_portrait.png"
}, {
  id: 4,
  name: "Kim Allen",
  position: "Youth and Community Outreach",
  bio: "Dedicated to making Dharma teachings accessible to all ages.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1444982/img/youth_outreach_teacher.png"
}];
const teacherLinks: Record<string, string> = {
  "David Lorey": "https://www.insightmeditationcenter.org/teachers-and-dharma-leaders/",
  "Ying Chen": "https://sati.org/certificate-programs/faculty/",
  "Diana Clark": "https://dianaclarkdharma.org/",
  "Kim Allen": "https://www.uncontrived.org/"
};
export default function MeetTheTeachers() {
  const {
    ref: groupRef,
    isVisible: groupVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section className="relative overflow-hidden bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1444982/img/redwood_heartwood_forest_background.png)] py-20 px-4 sm:px-6 lg:px-8">
      {}
      <div className="absolute inset-0 bg-primary-dark/40" />

      {}
      <div className="pointer-events-none absolute inset-0 opacity-10">
        <svg className="absolute top-0 left-0 h-64 w-64" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <path fill="currentColor" className="text-primary-light" d="M45.3,-59.8C58.9,-50.7,70.3,-36.9,75.6,-20.8C80.9,-4.7,80.1,13.7,72.8,28.9C65.5,44.1,51.7,56.1,36.2,63.4C20.7,70.7,3.5,73.3,-14.2,71.5C-31.9,69.7,-50.1,63.5,-63.8,51.8C-77.5,40.1,-86.7,22.9,-87.3,5.2C-87.9,-12.5,-79.9,-30.7,-67.8,-44.2C-55.7,-57.7,-39.5,-66.5,-23.1,-73.8C-6.7,-81.1,10,-86.9,24.8,-84.2C39.6,-81.5,31.7,-68.9,45.3,-59.8Z" transform="translate(100 100)" />
        </svg>
        <svg className="absolute bottom-0 right-0 h-64 w-64" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <path fill="currentColor" className="text-secondary-light" d="M39.5,-55.6C51.4,-46.3,61.5,-34.5,67.3,-20.2C73.1,-5.9,74.6,10.9,69.8,25.3C65,39.7,53.9,51.7,40.7,59.5C27.5,67.3,12.2,70.9,-3.8,71.4C-19.8,71.9,-36.4,69.3,-49.2,61.1C-62,52.9,-71,39.1,-75.4,24C-79.8,8.9,-79.6,-7.5,-74.3,-22.4C-69,-37.3,-58.6,-50.7,-45.4,-59.7C-32.2,-68.7,-16.1,-73.3,-0.5,-72.5C15.1,-71.7,27.6,-64.9,39.5,-55.6Z" transform="translate(100 100)" />
        </svg>
      </div>

      <div className="relative mx-auto max-w-7xl">
        {}
        <div ref={groupRef} className={`mb-16 flex justify-center transition-all duration-700 ease-out ${groupVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <div className="relative overflow-hidden rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.12)]">
            <img src="https://profound-pup.10web.cloud/wp-content/uploads/2025/11/IMG_4177.heic-scaled.jpg" alt="Four Dharma Friends" className="h-auto w-full max-w-2xl object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent" />
          </div>
        </div>

        {}
        <div ref={cardsRef} className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {teachers.map((teacher, i) => <div key={teacher.id} data-index={i} className={`transition-all duration-500 ease-out ${cardsVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`} style={{
          transitionDelay: cardsVisible ? `${i * 100}ms` : "0ms"
        }}>
              <div className="group flex flex-col items-center text-center">
                {teacherLinks[teacher.name] ? <Link to={teacherLinks[teacher.name]} newTab className="font-display text-xl font-semibold text-foreground-dark transition-all duration-200 hover:text-primary hover:scale-105">
                    {teacher.name}
                  </Link> : <h3 className="font-display text-xl font-semibold text-foreground-dark">
                    {teacher.name}
                  </h3>}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}